import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedirectGuard } from './core/redirect.guard';
import { RouteResolver } from './core/route-resolver.service';
import { PageComponent } from './ui/pages/home/page.component';
import { RedirectComponent } from './ui/pages/redirect/redirect.component';
import { RedirectLinkComponent } from './ui/redirect-link/redirect-link.component';
import { IframePageComponent } from './ui/organisms/iframe-page/iframe-page.component';

const routes: Routes = [
  {
    path: 'mobil',
    component: RedirectComponent,
    canActivate: [RedirectGuard],
  },
  {
    path: 'nkolaymobilindir',
    component: RedirectLinkComponent,
    data: { target: 'https://648y.tr.adj.st/?adj_t=1l8dxx5e&adj_fallback=https%3A%2F%2Fwww.nkolay.com%2Fnkolaymobilindir&adj_redirect_macos=https%3A%2F%2Fwww.nkolay.com%2Fnkolaymobilindir&adj_campaign=nkolayli_ol_buton' }
  },
   {
    path: 'blokesim',
    component: IframePageComponent,
    data: { 
      iframeUrl: 'https://mbs.aktifbank.com.tr/AnonymousIssueEntry.aspx?BusinessChannelID=bTlSdUMrVW9rbTV6WGZ4Z1hrdXRpQT090&CatID=2757',
      pageTitle: 'Aktif Bank Sim Bloke'
    },
  },
  {
    path: 'guncelcep',
    component: IframePageComponent,
    data: { 
      iframeUrl: 'https://mbs.aktifbank.com.tr/AnonymousIssueEntry.aspx?BusinessChannelID=bTlSdUMrVW9rbTV6WGZ4Z1hrdXRpQT090&CatID=2748',
      pageTitle: 'Aktif Bank Cep Guncel'
    },
  },
  {
    path: 'Agsblokekaldirma',
    component: IframePageComponent,
    data: { 
      iframeUrl: 'https://mbs.aktifbank.com.tr/AnonymousIssueEntry.aspx?BusinessChannelID=eDc3QjlHZ3kvU2xOL3hSUUI3YmttZz090&CatID=2759',
      pageTitle: 'Aktif Bank Cep Guncel'
    },
  },
  {
    path: 'iletisim',
    component: RedirectLinkComponent,
    data: { target: '/hakkimizda/bize-ulasin/iletisim-formu' }
  },
  {
    path: 'pttsms',
    component: RedirectLinkComponent,
    data: { target: '/emeklilere-ozel/sms-ile-pttden-kredi' }
  },
  {
    path: 'pttemekli',
    component: RedirectLinkComponent,
    data: { target: '/emeklilere-ozel/ptt-den-emekli-kredisi' }
  },
  {
    path: 'emekli',
    component: RedirectLinkComponent,
    data: { target: '/emeklilere-ozel'  }
  },
  {
    path: 'emekliptt',
    component: RedirectLinkComponent,
    data: { target: '/emeklilere-ozel/ptt-emekli-odeme-kampanyasi'  }
  },
  {
    runGuardsAndResolvers: 'always',
    path: '**',
    component: PageComponent,
    resolve: { pageContent: RouteResolver },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabled',
      useHash: false,
      scrollPositionRestoration: 'enabled',
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
